export default __webpack_public_path__ + "static/media/TOP-11-BASIC.40086cc4.jpg";